export default __webpack_public_path__ + "static/media/logo.955f17f3.png";